<template>
  <div>
    <div class="input-group" style="width: 100%">
      <input
        class="filter ui-icon-search"
        type="search"
        v-model="search"
        placeholder="Search waves"
      />
      <input
        type="submit"
        disabled="true"
        class="filter ui-icon-search-btn"
        value=""
      />
    </div>
    <div
      class="input-group btn-group btn-group-sm"
      role="group"
      aria-label="Basic example"
    >
      <button
        type="button"
        class="btn btn-default"
        :class="{ disabled: this.value.length === 0 }"
        @click.prevent="selectNone()"
      >
        clear selection
      </button>
    </div>
    <ul class="list-group">
      <a
        v-for="item in filtered"
        :key="item.id"
        href="#"
        @click.prevent="toggleSelected(item)"
        class="list-group-item list-group-item-action"
        :class="getClasses(item)"
        >{{ getLabel(item) }}</a
      >
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SelectableList',
  props: ['options', 'value', 'getItemClasses', 'getItemLabel', 'getItemValue'],
  data() {
    return { search: '' };
  },
  computed: {
    filtered() {
      return this.options.filter((option) =>
        option.name.toLowerCase().includes(this.search)
      );
    },
  },
  methods: {
    getClasses(item) {
      const isActive = this.isActive(item);

      const ourClasses = { active: isActive };
      const parentClasses =
        typeof this.getItemClasses === 'function'
          ? this.getItemClasses(item)
          : {};

      return {
        ...ourClasses,
        ...parentClasses,
      };
    },
    getLabel(item) {
      if (typeof this.getItemLabel === 'function') {
        return this.getItemLabel(item);
      }

      if (!item.name) {
        console.error('Item does not have a `name` property', item);
        throw new Error(
          'Item does not have a `name` property. Either add `name` to the query, or pass in a `getItemLabel` prop'
        );
      }

      return item.name;
    },
    getValue(item) {
      if (typeof this.getItemValue === 'function') {
        return this.getItemValue(item);
      }

      if (!item.id) {
        console.error('Item does not have a `id` property', item);
        throw new Error(
          'Item does not have a `id` property. Either add `id` to the query, or pass in a `getItemValue` prop'
        );
      }

      return item.id;
    },
    toggleSelected(item) {
      const value = this.getValue(item);
      const isSelected = this.value.find((v) => v === value);

      if (isSelected) {
        this.$emit(
          'input',
          this.value.filter((v) => v !== value)
        );
      } else {
        this.$emit('input', this.value.concat(value));
      }
    },
    isActive(item) {
      const value = this.getValue(item);
      const isSelected = this.value.find((v) => v === value);

      return isSelected;
    },
    selectNone() {
      this.$emit('input', []);
    },
  },
};
</script>

<style scoped>
.input-group {
  width: 100%;
  margin-bottom: 16px;
}
.filter {
  position: relative;
  width: 100%;
}
.filter.ui-icon-search-btn {
  position: absolute;
  right: 0;
  width: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectableList.vue